module.exports = ".errormsg {\n  width: 100%;\n  margin-top: 2px;\n  font-size: 80%;\n  color: #dc3545; }\n"